import axios from './axios';

export const serviceHandler = ({ url, payload = {}, methodType = 'get', options = {} }) => {
  if (methodType === 'delete') {
    return axios.delete(url, payload?.params ? payload : {
      data: payload,
      ...options
    }).then((response) => {
      if (response.status === 200) return { success: true, data: response.data };
      return { success: false };
    });
  }

  return axios[methodType](url, payload, options).then((response) => {
    if (response.status === 200) return { success: true, data: response.data };
    return { success: false };
  });
};
